import type React from 'react';
interface SectionTitleProps {
  children: React.ReactNode;
}
export const SectionTitle = ({
  children
}: SectionTitleProps) => <div className="mt-24 mb-16 w-full text-center" data-sentry-component="SectionTitle" data-sentry-source-file="SectionTitle.tsx">
    <h2 className="px-8 font-bold text-4xl">{children}</h2>
  </div>;
export default SectionTitle;